import type { Middleware, SWRHook } from 'swr'

import type { WebApiResponse } from ':/_types/webapi'

/**
 * SWR middleware to unwrap `data` and `meta` properties from our PHP API responses.
 *
 * With this you can do:
 * ```js
 * const { data, meta, error } = useSWR('/api/assemblies.json')
 * ```
 * to access the `{ data, meta }` properties from the PHP API directly.
 */
export const unwrapSWRResponse: Middleware = (useSWRNext: SWRHook) => {
  return (key, fetcher, config) => {
    const swr = useSWRNext(key, fetcher, config)

    let { data } = swr
    let meta = {}
    if (typeof data === 'object' && data !== null && 'data' in data) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ;({ data, meta } = data as unknown as WebApiResponse<any>)
    }

    return {
      ...swr,
      data,
      meta,
    }
  }
}
